import React, { useContext } from 'react'
import styled from 'styled-components'
import { Button, Tooltip } from 'antd'
import { FastForwardOutlined } from '@ant-design/icons'
import { FlexRow } from '../../FlexboxReusables/FlexItems'
import { FormattedMessage } from 'react-intl'
import { ParticipantCourseContext } from '../Context/ParticipantCourseContext'

const NavigationButtonsRow = () => {
  const {
    coursePages,
    currentPage,
    setCurrentPage,
    hasReachedLastPage,
    setIsStartExamModalVisible
  } = useContext(ParticipantCourseContext)

  return (
    <NavigationButtons>
      <Button
        type="default"
        onClick={() => currentPage > 0 && setCurrentPage(currentPage - 1)}
        disabled={currentPage === 0}
      >
        <FormattedMessage id='generic.back' />
      </Button>

      {!hasReachedLastPage
        ? (
          <div>
            <Button
              type="primary"
              onClick={() => currentPage < coursePages.length && setCurrentPage(currentPage + 1)}
            >
              <FormattedMessage id='generic.next' />
            </Button>
            <Tooltip
              title="Zum Ende springen"
              mouseEnterDelay={0}
            >
              <Button
                type="dashed"
                onClick={() => setCurrentPage(coursePages.length - 1)}
                style={{ marginLeft: '0.5em' }}
              >
                <FastForwardOutlined />
              </Button>
            </Tooltip>
          </div>
        )
        : (
          <Button
            type="primary"
            onClick={() => setIsStartExamModalVisible(true)}
          >
            <FormattedMessage id='generic.start' />
          </Button>
        )
      }

    </NavigationButtons>
  )
  
}

const NavigationButtons = styled(FlexRow)`
  justify-content: space-between;
  width: 90%;
  margin: 1em auto;
`

export default NavigationButtonsRow